import { Constants } from "@core/Utils/Constants";
import { Language, Messages } from '@core/GUI/Language';
import { effectsVolume } from "../../Utils/Constants";
import { Client } from "@core/Client";
import { MainScene } from "@core/Scenes/MainScene";

export class HelpScreen {
    public hidden: boolean = true;
    public hasJackpotPage: boolean = false;
    public hasFiguresPage: boolean = false;

    protected portrait: boolean = false;
    protected staticHeight: number = 0;
    protected staticWidth: number = 0;
    protected horizontalPadding: number = 0;
    protected verticalPadding: number = 0;

    protected mainTitle: Phaser.GameObjects.Text;
    protected subTitles: Array<Phaser.GameObjects.Text>; //Lists all pages and marks active page

    protected closeButton: Phaser.GameObjects.Image;
    protected nextPageButton: Phaser.GameObjects.Image;
    protected previousPageButton: Phaser.GameObjects.Image;
    protected backgroundImage: Phaser.GameObjects.Image;

    protected activePage: number = 0;
    protected pages: Array<Page> = new Array<Page>();
    protected pageContainerWidth = 0;
    protected pageContainerHeight = 0;

    constructor(protected scene: Phaser.Scene) {
        this.horizontalPadding = this.scene.renderer.width / 100;
        this.verticalPadding = this.scene.renderer.height / 100;

        this.backgroundImage = this.scene.add.image(0, 0, Constants.SPRITESHEET_GAME_BACKGROUND)
        this.backgroundImage.setOrigin(0);
        this.backgroundImage.setDisplaySize(this.scene.renderer.width, this.scene.renderer.height);
        this.backgroundImage.setInteractive();
        this.backgroundImage.on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
        }, this);
        this.backgroundImage.on("pointerup", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
        }, this);
        this.backgroundImage.on("pointermove", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
        }, this);

        Client.game.events.addListener(Constants.EVENTS.LANGUAGE_CHANGED, () => this.TranslatePages())
        Client.game.events.addListener(Constants.EVENTS.BETS_CLOSED_TRIGGERED, () => {
            if (Client.logic.BetSum > 0)
                this.Hide()
        })

        this.mainTitle = this.scene.add.text(this.scene.renderer.width / 2, 30, Language.Get(Messages.HELP_TITLE), {
            fontFamily: 'Arial',
            fontSize: '38px',
            color: '#ffffff',
            align: 'center',
            stroke: '#ffffff',
            strokeThickness: 1,
        });
        this.mainTitle.setOrigin(0.5);
        this.mainTitle.setFontSize(25);

        this.closeButton = this.scene.add.image(this.scene.renderer.width - 30, 30, Constants.SPRITESHEET_MENU, "MenuIcon_Close.png");
        this.closeButton.setInteractive();
        this.closeButton.setDisplaySize(35, 35);
        this.closeButton.setOrigin(0.5);
        this.closeButton.on("pointerup", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
            this.Hide();
        }, this);

        this.nextPageButton = this.scene.add.image(this.scene.renderer.width - 55, this.scene.renderer.height / 2, Constants.SPRITESHEET_MENU, "MenuIcon_PreviousPage.png");
        this.nextPageButton.flipX = true;
        this.nextPageButton.setInteractive();
        this.nextPageButton.setDisplaySize(50, 100);
        this.nextPageButton.setOrigin(0.5);
        this.nextPageButton.on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
            this.NextPage();
        }, this);

        this.previousPageButton = this.scene.add.image(55, this.scene.renderer.height / 2, Constants.SPRITESHEET_MENU, "MenuIcon_PreviousPage.png");
        this.previousPageButton.setInteractive();
        this.previousPageButton.setDisplaySize(50, 100);
        this.previousPageButton.setOrigin(0.5);
        this.previousPageButton.on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
            this.PreviousPage();
        }, this);

        this.mainTitle.visible = this.backgroundImage.visible = this.closeButton.visible = this.nextPageButton.visible = this.previousPageButton.visible = !this.hidden;

        this.scene.game.events.on(Constants.EVENTS.TOGGLE_HELP, () => { this.Toggle(); });
    }

    public NextPage(): void {
        if (this.hidden)
            return;

        this.activePage += 1;

        if (this.activePage > this.pages.length - 1) {
            this.activePage = 0;
        }

        this.UpdateSubtitle();
    }

    public PreviousPage(): void {
        if (this.hidden)
            return;

        this.activePage -= 1;

        if (this.activePage < 0) {
            this.activePage = this.pages.length - 1;
        }

        this.UpdateSubtitle();
    }

    public Toggle(): void {
        this.hidden = !this.hidden;

        if (this.hidden)
            this.Hide();
        else
            this.Show();

        Client.remote.RemoteActionsHaveChanged();
    }

    public Hide(): void {
        if (Client.slot) {
            Client.logic.UpdateFlags(false, "infopages", true);
            (this.scene as MainScene).slotExitButton.visible = true;
        }
        this.hidden = true;
        this.activePage = 0;
        Client.logic.lockBetting = false;

        if (!Client.logic.showStatistics) {
            this.scene.game.events.emit("showVideo");
        }

        this.pages.forEach((page, index) => {
            page.container.visible = false;
            this.subTitles[index].visible = false;
        });

        this.mainTitle.visible = this.backgroundImage.visible = this.closeButton.visible = this.nextPageButton.visible = this.previousPageButton.visible = !this.hidden;
    }

    public Show(): void {
        if (Client.slot) {
            Client.logic.UpdateFlags(true, "infopages", true);
            (this.scene as MainScene).slotExitButton.visible = false;
        }
        Client.logic.lockBetting = true;
        this.hidden = false;
        this.mainTitle.visible = this.backgroundImage.visible = this.closeButton.visible = this.nextPageButton.visible = this.previousPageButton.visible = !this.hidden;
        this.UpdateSubtitle();
        this.scene.game.events.emit("hideVideo");
        this.subTitles.forEach(text => {
            text.visible = true;
        });
    }

    protected UpdateSubtitle(): void {
        this.pages.forEach((page, index) => {
            if (!this.hidden && index == this.activePage) {
                page.container.visible = true;
                this.subTitles[index].setStyle({
                    fontFamily: 'Arial',
                    color: '#ffffff',
                    align: 'center'
                })
            } else {
                page.container.visible = false;
                this.subTitles[index].setStyle({
                    fontFamily: 'Arial',
                    color: '#777777',
                    align: 'center'
                })
            }
        });
    }

    public Resize(width: number, height: number, portraitMode: boolean): void {
        if (!this.subTitles)
            return;

        this.mainTitle.text = Language.Get(Messages.HELP_TITLE);

        this.portrait = portraitMode;
        this.staticHeight = height;
        this.staticWidth = width;

        this.horizontalPadding = width * 0.02;
        this.verticalPadding = height * 0.02;

        let buttonSize = 1;
        if (this.scene.game.device.os.desktop) {
            buttonSize = Math.min(width * 0.08, height * 0.08);
        } else {
            buttonSize = Math.min(width * 0.12, height * 0.12);
        }

        this.backgroundImage.setDisplaySize(width, height);
        this.closeButton.setDisplaySize(buttonSize, buttonSize);
        this.nextPageButton.setDisplaySize(buttonSize, buttonSize * 2);
        this.previousPageButton.setDisplaySize(buttonSize, buttonSize * 2);
        this.mainTitle.setFontSize(buttonSize / 2);

        this.backgroundImage.y = 0;
        this.closeButton.setPosition(width - buttonSize / 2 - this.verticalPadding, buttonSize / 2 + this.verticalPadding);
        this.nextPageButton.setPosition(width - buttonSize / 2 - this.horizontalPadding / 2, height / 2);
        this.previousPageButton.setPosition(buttonSize / 2 + this.horizontalPadding / 2, height / 2);
        this.mainTitle.setPosition(width / 2, this.mainTitle.displayHeight / 2);

        if (portraitMode) {
            this.backgroundImage.y = -height;
            this.closeButton.y -= height;
            this.nextPageButton.y -= height;
            this.previousPageButton.y -= height;
            this.mainTitle.y -= height;
        }

        let totalTextLength: number = 0;
        this.subTitles.forEach((text, index) => {
            text.setFontSize(buttonSize / 2.5);
            totalTextLength += text.displayWidth + this.horizontalPadding;
        });
        let lengthBehindMe = 0;
        this.subTitles.forEach((text, index) => {
            if (index > 0)
                lengthBehindMe += this.subTitles[index - 1].displayWidth + this.horizontalPadding;
            text.setPosition(width / 2 - totalTextLength / 2 + lengthBehindMe, this.mainTitle.displayHeight / 2 + text.displayHeight);

            if (portraitMode)
                text.y -= height;
        });

        this.pageContainerHeight = height - (this.subTitles[0].y + this.subTitles[0].displayHeight + this.verticalPadding * 15);
        this.pageContainerWidth = width - buttonSize * 2 - this.horizontalPadding * 4;

        this.pages.forEach((page) => {
            page.container.displayWidth = width * 0.85
            page.container.displayHeight = height * 0.89
            page.container.setScale(Math.min(page.container.scaleX, page.container.scaleY))
            page.container.x = width / 2 - (page.container.width * page.container.scaleX) / 2;
            page.container.y = this.subTitles[0].y + this.subTitles[0].displayHeight + this.verticalPadding / 2;
        });
    }

    public TranslatePages(): void {
        console.log(this.subTitles, this.pages)
        this.pages.forEach((page, index) => {
            page.name = this.subTitles[index].getData('message')()();
            page.container.list.forEach((element: any) => {
                if (element.type !== "Text") return
                try {
                    element.setText(element.getData("message")())
                } catch (e) { }
            })
        })
        this.subTitles.forEach(subtitle => {
            console.log(subtitle.getData('message')()())
            subtitle.setText(subtitle.getData('message')()())
        })
        console.log(this.subTitles, this.pages)
    }
}

export class Page {
    public name;
    public container: Phaser.GameObjects.Container;
    public getPageName;

    constructor(getPageName, container: Phaser.GameObjects.Container) {
        this.getPageName = getPageName;
        this.container = container;
    }
}